import { isSmallScreen } from './utils';

export const categories = [
  {
    key: 'superfood',
    color: '#7F63D2',
    minColor: '#E5E0F6',
    label: 'Superfoods',
  },
  {
    key: 'nuesse',
    color: '#905B30',
    minColor: '#e6d9d0',
    label: 'Nüsse',
  },
  {
    key: 'trockenfruechte',
    color: '#76B7B2',
    minColor: '#e0efee',
    label: 'Trockenfrüchte',
  },
  {
    key: 'snacks',
    color: '#B1023B',
    minColor: '#edc5d3',
    label: 'Snacks',
  },
  {
    key: 'backen',
    color: '#FDBD4F',
    minColor: '#fff0d7',
    label: 'Backen & Kochen',
  },
  {
    key: 'fruehstueck',
    color: '#AFBA5C',
    minColor: '#edefd8',
    label: 'Frühstück',
  },
  {
    key: 'zubehoer',
    color: '#F98058',
    minColor: '#ffe2d9',
    label: 'Zubehör',
  },
  {
    key: null,
    color: '#7AA2CD',
    minColor: '#e0e9f4',
    label: 'Alle Kategorien',
  },
];

export const countryCol = 'country';
export const weightCol = 'totalweight';
export const categoryCol = 'category';
export const idCol = 'mainnumber';
export const nameCol = 'name';
export const amountCol = 'totalamount';
export const transportCol = 'transport';
export const imgCol = 'picture';
export const linkCol = 'link';
export const funfactCol = 'funfact';

export const bubbleMinRadius = isSmallScreen ? 2 : 5;
// only useed for the legend
export const bubbleMedRadius = isSmallScreen ? 8 : 15;
export const bubbleMaxRadius = isSmallScreen ? 12 : 25;

export const articleLegendItems = [20, 40, 60, 80];

export const targetIsoCode = 'de';

export const csvBasePath =
  __ENV__ === 'koro'
    ? 'https://www.korodrogerie.de/mapfiles/german/'
    : 'build/';

export const imgBasePath =
  __ENV__ === 'koro'
    ? 'https://www.korodrogerie.de/mapfiles/german/'
    : 'build/';

export const productShopBaseUrl =
  'https://www.korodrogerie.de/detail/index/sArticle/';

export const productImgBaseUrl =
  'https://d1v549azfiolas.cloudfront.net/media/image/';

export const foodJournalLink = 'https://korodrogerie.de/blog/detail/sCategory/81/blogArticle/1463';

export default {
  categories,
  countryCol,
  weightCol,
  categoryCol,
  idCol,
  nameCol,
  amountCol,
  transportCol,
  imgCol,
  linkCol,
  funfactCol,
  bubbleMinRadius,
  bubbleMaxRadius,
  articleLegendItems,
};
